
















































import { Component, Vue } from "@/shared/vuepack";

import Checkbox from "@/shared/components/ui/Checkbox.vue";
import { AdvisorDeliveryPage } from "@/shared/types";
import { useUserAdvisorStore } from "@/shared/store/userAdvisor";

@Component({
  components: {
    Checkbox
  }
})
export default class AdvisorAlert extends Vue {
  userAdvisorStore = useUserAdvisorStore();

  adviceText (deliveryPage: string) {
    switch (deliveryPage) {
      case AdvisorDeliveryPage.HealthcareExpense:
        return "Expense";
      case AdvisorDeliveryPage.None:
      case AdvisorDeliveryPage.Dashboard:
        return "";
      case AdvisorDeliveryPage.Cash:
        return "Cash";
      case AdvisorDeliveryPage.Investment:
        return "Investment";
      case AdvisorDeliveryPage.Reimburse:
        return "Reimbursements";
      case AdvisorDeliveryPage.Contributions:
        return "Contributions";
      case AdvisorDeliveryPage.ContributionPlanner:
        return "Contribution Planner";
      case AdvisorDeliveryPage.Resources:
        return "Resources";
      case AdvisorDeliveryPage.Settings:
        return "Settings";
      default:
        return "";
    }
  }

  isRouteLink (advice) {
    return advice.link && advice.isRouteLink;
  }

  linkTarget (advice) {
   return advice.isLinkTargetNew ? "_blank" : "_self";
  }

  get displayMessageCounter (): boolean {
    return !!this.unreadCount;
  }

  get unreadCount () {
    if (!this.userAdvisorStore.advices) return 0;
    return this.userAdvisorStore.advices.length;
  }
}
